
import {
    Box,
    Divider,
    Grid,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    Chip,
    Container
} from "@mui/material";

import { useEffect, useRef, useState } from "react";
import axios from "axios";

import marketMap from "../../assets/market.jpg";
import config from "../../config.json";
import { ItemsImages } from "../../utils/items-list";

export const MarketPlacePage = () => {
    const apiEndPoint = config.apiEndPoint + "info/marketplace";

    const [result, setResult] = useState([]);
    const [enabled, setEnabled] = useState(false);
    const [posXMg, setPosXMg] = useState(0);
    const [posYMg, setPosYMg] = useState(0);

    const imgRef = useRef();

    useEffect(() => {
        axios
            .get(apiEndPoint)
            .then((response) => response.data)
            .then((data) => setResult(data));
    }, []);

    const mapWidth = 512;
    const mapHeight = 512;

    const hoverItem = (item) => {
        setEnabled(true);

        let posX = parseInt(item.positionX);
        let posY = parseInt(item.positionY);

        const newX = (posX - posY) * 32 + 8192 / 2;
        const newY = (posX + posY - (384 - 1)) * (32 / 2) + 8192 / 2;

        posX = newX * 0.0625;
        posY = newY * 0.0625;

        const elemWidth = imgRef.current.width;
        const elemHeight = imgRef.current.height;

        const scaleWidth = elemWidth / mapWidth;
        const scaleHeight = elemHeight / mapHeight;

        posX *= scaleWidth;
        posY *= scaleHeight;

        posX -= 12.5;
        posY -= 12.5;

        setPosXMg(posX);
        setPosYMg(posY);
    };

    const renderItems = () => (
        <TableContainer
            component={Paper}
            sx={{
                background:
                    "linear-gradient(145deg, rgba(18,10,8,0.98), rgba(6,6,6,0.99))",
                backdropFilter: "blur(18px)",
                border:
                    "1px solid rgba(255,84,32,0.15)",
                borderRadius: "18px",
                boxShadow:
                    "0 20px 55px rgba(0,0,0,0.5)",
                overflow: "auto",

                "&::-webkit-scrollbar": {
                    height: "7px",
                },

                "&::-webkit-scrollbar-track": {
                    background: "#080808",
                },

                "&::-webkit-scrollbar-thumb": {
                    background:
                        "linear-gradient(90deg, #8e1d0b, #ff5420)",
                    borderRadius: "10px",
                },

                "&::-webkit-scrollbar-thumb:hover": {
                    background: "#ff7135",
                },
            }}
        >
            <Table
                stickyHeader
                sx={{
                    minWidth: 850,
                    borderCollapse: "separate",
                    borderSpacing: "0 3px",
                }}
            >
                <TableHead>
                    <TableRow>
                        {[
                            "Item",
                            "Quality",
                            "Plus",
                            "Gem 1",
                            "Gem 2",
                            "Seller",
                            "Price"
                        ].map((h, i) => (
                            <TableCell
                                key={i}
                                sx={{
                                    background:
                                        "linear-gradient(180deg, #15100e, #0b0b0b)",
                                    color: "#ff7135",
                                    fontWeight: 900,
                                    fontSize: "10px",
                                    letterSpacing: "1.5px",
                                    textTransform: "uppercase",
                                    borderBottom:
                                        "1px solid rgba(255,84,32,0.18)",
                                    py: 2.2,
                                    whiteSpace: "nowrap",
                                }}
                            >
                                {h}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>

                <TableBody>
                    {result.map((item, index) => (
                        <TableRow
                            key={index}
                            hover
                            onMouseEnter={() => hoverItem(item)}
                            onMouseLeave={() => setEnabled(false)}
                            sx={{
                                background:
                                    index % 2 === 0
                                        ? "rgba(255,255,255,0.012)"
                                        : "rgba(255,84,32,0.008)",
                                transition:
                                    "all 0.22s ease",
                                position: "relative",

                                "&:hover": {
                                    background:
                                        "linear-gradient(90deg, rgba(255,84,32,0.09), rgba(255,84,32,0.015))",
                                },

                                "& td": {
                                    borderBottom:
                                        "1px solid rgba(255,255,255,0.035)",
                                },
                            }}
                        >
                            {/* =================================================
                                ITEM
                            ================================================== */}
                            <TableCell
                                sx={{
                                    py: 1.8,
                                    minWidth: 230,
                                }}
                            >
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 1.5,
                                    }}
                                >
                                    <Box
                                        component="img"
                                        src={`/ items / ${ ItemsImages.get(item.itemId?.toString()) ?? ItemsImages.get("Default") }`}
                                        sx={{
                                            width: 44,
                                            height: 44,
                                            borderRadius: "11px",
                                            background:
                                                "linear-gradient(145deg, #19110f, #090909)",
                                            border:
                                                "1px solid rgba(255,84,32,0.16)",
                                            p: 0.5,
                                            objectFit: "contain",
                                            transition:
                                                "all 0.25s ease",

                                            "&:hover": {
                                                transform:
                                                    "scale(1.08)",
                                                borderColor:
                                                    "rgba(255,84,32,0.45)",
                                                boxShadow:
                                                    "0 0 18px rgba(255,70,25,0.18)",
                                            },
                                        }}
                                    />

                                    <Box
                                        sx={{
                                            minWidth: 0,
                                        }}
                                    >
                                        <Typography
                                            sx={{
                                                color: "#eee",
                                                fontWeight: 800,
                                                fontSize: "13px",
                                                overflow:
                                                    "hidden",
                                                textOverflow:
                                                    "ellipsis",
                                                whiteSpace:
                                                    "nowrap",
                                            }}
                                        >
                                            {item.itemName}
                                        </Typography>

                                        <Typography
                                            sx={{
                                                color: "#5a5a5a",
                                                fontSize: "9px",
                                                mt: 0.4,
                                                fontWeight: 800,
                                                letterSpacing:
                                                    "1px",
                                            }}
                                        >
                                            MARKET ITEM
                                        </Typography>
                                    </Box>
                                </Box>
                            </TableCell>

                            {/* =================================================
                                QUALITY
                            ================================================== */}
                            <TableCell
                                sx={{
                                    color: "#ccc",
                                    whiteSpace: "nowrap",
                                }}
                            >
                                <Chip
                                    label={item.quality || "Fixed"}
                                    size="small"
                                    sx={{
                                        height: 27,
                                        background:
                                            "linear-gradient(135deg, rgba(255,84,32,0.14), rgba(181,42,13,0.06))",
                                        border:
                                            "1px solid rgba(255,84,32,0.22)",
                                        color: "#ff7135",
                                        fontWeight: 800,
                                        fontSize: "10px",
                                        "& .MuiChip-label": {
                                            px: 1.3,
                                        },
                                    }}
                                />
                            </TableCell>

                            {/* =================================================
                                PLUS
                            ================================================== */}
                            <TableCell
                                sx={{
                                    color: "#ff7135",
                                    fontWeight: 900,
                                    fontSize: "13px",
                                    whiteSpace: "nowrap",
                                }}
                            >
                                <Box
                                    component="span"
                                    sx={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        minWidth: 38,
                                        px: 0.8,
                                        py: 0.45,
                                        borderRadius: "6px",
                                        background:
                                            "rgba(255,84,32,0.08)",
                                        border:
                                            "1px solid rgba(255,84,32,0.13)",
                                    }}
                                >
                                    +{item.plus}
                                </Box>
                            </TableCell>

                            {/* =================================================
                                GEM 1
                            ================================================== */}
                            <TableCell
                                sx={{
                                    color: item.gem1
                                        ? "#aaa"
                                        : "#444",
                                    fontWeight: 600,
                                    fontSize: "12px",
                                }}
                            >
                                {item.gem1 || "-"}
                            </TableCell>

                            {/* =================================================
                                GEM 2
                            ================================================== */}
                            <TableCell
                                sx={{
                                    color: item.gem2
                                        ? "#aaa"
                                        : "#444",
                                    fontWeight: 600,
                                    fontSize: "12px",
                                }}
                            >
                                {item.gem2 || "-"}
                            </TableCell>

                            {/* =================================================
                                SELLER
                            ================================================== */}
                            <TableCell
                                sx={{
                                    color: "#eee",
                                    fontWeight: 700,
                                    fontSize: "12px",
                                    whiteSpace: "nowrap",
                                }}
                            >
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 0.8,
                                    }}
                                >
                                    <Box
                                        sx={{
                                            width: 6,
                                            height: 6,
                                            borderRadius: "50%",
                                            background:
                                                "#ff5420",
                                            boxShadow:
                                                "0 0 9px rgba(255,84,32,0.55)",
                                        }}
                                    />

                                    {item.seller}
                                </Box>
                            </TableCell>

                            {/* =================================================
                                PRICE
                            ================================================== */}
                            <TableCell
                                sx={{
                                    color: "#4ade80",
                                    fontWeight: 900,
                                    fontSize: "13px",
                                    whiteSpace: "nowrap",
                                }}
                            >
                                <Box
                                    component="span"
                                    sx={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                        px: 1,
                                        py: 0.45,
                                        borderRadius: "6px",
                                        background:
                                            "rgba(74,222,128,0.055)",
                                        border:
                                            "1px solid rgba(74,222,128,0.1)",
                                    }}
                                >
                                    {item.price?.toLocaleString()}
                                </Box>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>

            {result.length === 0 && (
                <Box
                    sx={{
                        py: 9,
                        px: 3,
                        textAlign: "center",
                    }}
                >
                    <Box
                        sx={{
                            width: 58,
                            height: 58,
                            mx: "auto",
                            mb: 2,
                            borderRadius: "50%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            background:
                                "rgba(255,84,32,0.06)",
                            border:
                                "1px solid rgba(255,84,32,0.15)",
                            color: "#ff5420",
                            fontSize: "22px",
                        }}
                    >
                        ⚔
                    </Box>

                    <Typography
                        sx={{
                            color: "#666",
                            fontWeight: 700,
                            fontSize: "14px",
                        }}
                    >
                        No marketplace items available
                    </Typography>

                    <Typography
                        sx={{
                            color: "#444",
                            fontSize: "11px",
                            mt: 1,
                        }}
                    >
                        The marketplace is currently empty.
                    </Typography>
                </Box>
            )}
        </TableContainer>
    );

    const renderMap = () => (
        <Box
            sx={{
                position: "relative",
                borderRadius: "18px",
                overflow: "hidden",
                border:
                    "1px solid rgba(255,84,32,0.16)",
                background: "#080808",
                boxShadow:
                    "0 15px 40px rgba(0,0,0,0.5)",
            }}
        >
            {/* =================================================
                MAP MARKER
            ================================================== */}
            {enabled && (
                <Box
                    sx={{
                        position: "absolute",
                        top: posYMg,
                        left: posXMg,
                        zIndex: 5,
                        pointerEvents: "none",
                    }}
                >
                    <Box
                        sx={{
                            position: "relative",
                            width: 20,
                            height: 20,
                            borderRadius: "50%",
                            border:
                                "3px solid #ff5420",
                            background:
                                "rgba(255,84,32,0.28)",
                            animation:
                                "pulse 1.5s infinite",
                            boxShadow:
                                "0 0 20px rgba(255,84,32,0.7)",

                            "@keyframes pulse": {
                                "0%": {
                                    transform:
                                        "scale(0.8)",
                                    opacity: 1,
                                },
                                "100%": {
                                    transform:
                                        "scale(2.2)",
                                    opacity: 0,
                                },
                            },
                        }}
                    />

                    {/* CENTER DOT */}
                    <Box
                        sx={{
                            position: "absolute",
                            width: 6,
                            height: 6,
                            borderRadius: "50%",
                            background: "#fff",
                            top: 4,
                            left: 4,
                            boxShadow:
                                "0 0 8px rgba(255,255,255,0.8)",
                        }}
                    />
                </Box>
            )}

            {/* =================================================
                MAP IMAGE
            ================================================== */}
            <Box
                component="img"
                ref={imgRef}
                src={marketMap}
                sx={{
                    width: "100%",
                    display: "block",
                    minHeight: {
                        xs: 300,
                        md: 420,
                    },
                    objectFit: "cover",
                    filter:
                        "brightness(0.78) saturate(0.9)",
                }}
            />

            {/* =================================================
                MAP OVERLAY
            ================================================== */}
            <Box
                sx={{
                    position: "absolute",
                    inset: 0,
                    background:
                        "linear-gradient(to top, rgba(0,0,0,0.92) 0%, rgba(0,0,0,0.22) 45%, rgba(255,60,20,0.025) 100%)",
                    pointerEvents: "none",
                }}
            />

            {/* MAP FIRE GLOW */}
            <Box
                sx={{
                    position: "absolute",
                    top: -120,
                    right: -100,
                    width: 280,
                    height: 280,
                    borderRadius: "50%",
                    background:
                        "rgba(255,70,25,0.08)",
                    filter: "blur(70px)",
                    pointerEvents: "none",
                }}
            />

            {/* =================================================
                MAP TOP BADGE
            ================================================== */}
            <Box
                sx={{
                    position: "absolute",
                    top: 18,
                    left: 18,
                    display: "flex",
                    alignItems: "center",
                    gap: 0.8,
                    px: 1.5,
                    py: 0.7,
                    borderRadius: "9px",
                    background:
                        "rgba(5,5,5,0.82)",
                    border:
                        "1px solid rgba(255,84,32,0.2)",
                    backdropFilter: "blur(8px)",
                }}
            >
                <Box
                    sx={{
                        width: 6,
                        height: 6,
                        borderRadius: "50%",
                        background: "#ff5420",
                        boxShadow:
                            "0 0 10px rgba(255,84,32,0.8)",
                    }}
                />

                <Typography
                    sx={{
                        color: "#ff7135",
                        fontSize: "9px",
                        fontWeight: 900,
                        letterSpacing: "1.5px",
                    }}
                >
                    LIVE MAP
                </Typography>
            </Box>

            {/* =================================================
                MAP INFORMATION
            ================================================== */}
            <Box
                sx={{
                    position: "absolute",
                    bottom: 20,
                    left: 20,
                    right: 20,
                }}
            >
                <Typography
                    sx={{
                        color: "#ff7135",
                        fontWeight: 900,
                        fontSize: "20px",
                        textShadow:
                            "0 2px 15px rgba(0,0,0,0.8)",
                    }}
                >
                    Market Map
                </Typography>

                <Typography
                    sx={{
                        color: "#ccc",
                        fontSize: 12,
                        mt: 0.5,
                    }}
                >
                    Hover items to locate sellers
                </Typography>

                <Box
                    sx={{
                        width: 55,
                        height: 2,
                        background:
                            "linear-gradient(90deg, #ff5420, transparent)",
                        mt: 1.5,
                        boxShadow:
                            "0 0 10px rgba(255,84,32,0.35)",
                    }}
                />
            </Box>
        </Box>
    );

    return (
        <Box
            sx={{
                minHeight: "100vh",
                py: {
                    xs: 5,
                    sm: 7,
                    md: 10,
                },
                position: "relative",
                overflow: "hidden",
                background:
                    "radial-gradient(circle at 50% -10%, rgba(255,75,30,0.18), transparent 35%), radial-gradient(circle at 100% 50%, rgba(213,47,12,0.055), transparent 30%), linear-gradient(180deg, #030303 0%, #080808 55%, #020202 100%)",
                color: "#fff",

                "&:before": {
                    content: '""',
                    position: "absolute",
                    top: 0,
                    left: "50%",
                    transform:
                        "translateX(-50%)",
                    width: "70%",
                    height: "1px",
                    background:
                        "linear-gradient(90deg, transparent, rgba(255,84,32,0.85), transparent)",
                },
            }}
        >
            {/* =========================================================
                BACKGROUND FIRE GLOW
            ========================================================== */}
            <Box
                sx={{
                    position: "absolute",
                    top: "-250px",
                    right: "-250px",
                    width: 650,
                    height: 650,
                    borderRadius: "50%",
                    background:
                        "radial-gradient(circle, rgba(255,75,30,0.11) 0%, transparent 68%)",
                    filter: "blur(110px)",
                    pointerEvents: "none",
                }}
            />

            <Box
                sx={{
                    position: "absolute",
                    bottom: "-300px",
                    left: "-300px",
                    width: 700,
                    height: 700,
                    borderRadius: "50%",
                    background:
                        "radial-gradient(circle, rgba(213,47,12,0.05) 0%, transparent 68%)",
                    filter: "blur(120px)",
                    pointerEvents: "none",
                }}
            />

            {/* =========================================================
                BACKGROUND GRID
            ========================================================== */}
            <Box
                sx={{
                    position: "absolute",
                    inset: 0,
                    opacity: 0.035,
                    pointerEvents: "none",
                    backgroundImage:
                        "linear-gradient(rgba(255,84,32,0.65) 1px, transparent 1px), linear-gradient(90deg, rgba(255,84,32,0.65) 1px, transparent 1px)",
                    backgroundSize: "45px 45px",
                    maskImage:
                        "linear-gradient(to bottom, black, transparent 85%)",
                    WebkitMaskImage:
                        "linear-gradient(to bottom, black, transparent 85%)",
                }}
            />

            <Container
                maxWidth="xl"
                sx={{
                    position: "relative",
                    zIndex: 2,
                }}
            >
                {/* =====================================================
                    HEADER
                ====================================================== */}
                <Box
                    sx={{
                        textAlign: "center",
                        mb: {
                            xs: 5,
                            md: 7,
                        },
                    }}
                >
                    {/* LIVE BADGE */}
                    <Box
                        sx={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: 1,
                            px: 2,
                            py: 0.8,
                            mb: 2,
                            borderRadius: "30px",
                            border:
                                "1px solid rgba(255,84,32,0.2)",
                            background:
                                "rgba(255,65,25,0.055)",
                            boxShadow:
                                "0 0 30px rgba(255,65,25,0.05)",
                        }}
                    >
                        <Box
                            sx={{
                                width: 7,
                                height: 7,
                                borderRadius: "50%",
                                background: "#ff5420",
                                boxShadow:
                                    "0 0 12px rgba(255,84,32,0.9)",
                            }}
                        />

                        <Typography
                            sx={{
                                color: "#ff7135",
                                letterSpacing: "3px",
                                fontWeight: 800,
                                fontSize: "10px",
                            }}
                        >
                            VEX • LIVE MARKET
                        </Typography>
                    </Box>

                    <Typography
                        sx={{
                            fontSize: {
                                xs: "40px",
                                sm: "50px",
                                md: "62px",
                            },
                            fontWeight: 900,
                            lineHeight: 1,
                            letterSpacing: "-1px",
                            color: "#fff",
                            mb: 2.5,
                            textShadow:
                                "0 5px 35px rgba(0,0,0,0.6)",
                        }}
                    >
                        Vex{" "}
                        <Box
                            component="span"
                            sx={{
                                color: "#ff6030",
                                textShadow:
                                    "0 0 30px rgba(255,82,35,0.22)",
                            }}
                        >
                            Marketplace
                        </Box>
                    </Typography>

                    <Typography
                        sx={{
                            color:
                                "rgba(255,255,255,0.55)",
                            maxWidth: 700,
                            mx: "auto",
                            fontSize: {
                                xs: "14px",
                                md: "16px",
                            },
                            lineHeight: 1.8,
                        }}
                    >
                        Browse items being sold by players,
                        check equipment details, and locate
                        sellers around the market in real time.
                    </Typography>

                    {/* DECORATIVE LINE */}
                    <Box
                        sx={{
                            width: 105,
                            height: 3,
                            borderRadius: "10px",
                            background:
                                "linear-gradient(90deg, transparent, #ff5420, #ff9a4d, #ff5420, transparent)",
                            mx: "auto",
                            mt: 3,
                            boxShadow:
                                "0 0 18px rgba(255,82,32,0.3)",
                        }}
                    />

                    {/* SERVER TAGS */}
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            flexWrap: "wrap",
                            gap: 1,
                            mt: 3,
                        }}
                    >
                        {[
                            "5165 CLASSIC",
                            "PLAYER MARKET",
                            "LIVE LISTINGS",
                            "SELLER MAP",
                        ].map((tag) => (
                            <Box
                                key={tag}
                                sx={{
                                    px: 1.5,
                                    py: 0.7,
                                    borderRadius: "7px",
                                    border:
                                        "1px solid rgba(255,91,45,0.12)",
                                    background:
                                        "rgba(255,255,255,0.025)",
                                    color: "#777",
                                    fontSize: "9px",
                                    fontWeight: 800,
                                    letterSpacing: "1px",
                                }}
                            >
                                {tag}
                            </Box>
                        ))}
                    </Box>
                </Box>

                {/* =====================================================
                    MARKET CONTENT
                ====================================================== */}
                <Grid
                    container
                    spacing={{
                        xs: 3,
                        md: 4,
                    }}
                    alignItems="stretch"
                >
                    {/* =================================================
                        ITEMS
                    ================================================== */}
                    <Grid item xs={12} lg={8}>
                        <Paper
                            elevation={0}
                            sx={{
                                height: "100%",
                                p: {
                                    xs: 1.5,
                                    sm: 2,
                                    md: 2.5,
                                },
                                background:
                                    "linear-gradient(145deg, rgba(18,10,8,0.98), rgba(7,7,7,0.99))",
                                border:
                                    "1px solid rgba(255,84,32,0.16)",
                                borderRadius: {
                                    xs: "20px",
                                    md: "24px",
                                },
                                boxShadow:
                                    "0 25px 70px rgba(0,0,0,0.55)",
                                position: "relative",
                                overflow: "hidden",

                                "&:before": {
                                    content: '""',
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    height: "2px",
                                    background:
                                        "linear-gradient(90deg, transparent, #b52a0d, #ff7135, #ff9a4d, #ff5420, transparent)",
                                },
                            }}
                        >
                            {/* SECTION HEADER */}
                            <Box
                                sx={{
                                    px: {
                                        xs: 1,
                                        sm: 1.5,
                                    },
                                    pt: 1,
                                    pb: 2.5,
                                }}
                            >
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent:
                                            "space-between",
                                        gap: 2,
                                    }}
                                >
                                    <Box>
                                        <Typography
                                            sx={{
                                                color: "#ff7135",
                                                fontSize: "10px",
                                                fontWeight: 800,
                                                letterSpacing:
                                                    "2px",
                                                textTransform:
                                                    "uppercase",
                                                mb: 0.7,
                                            }}
                                        >
                                            PLAYER TRADING
                                        </Typography>

                                        <Typography
                                            sx={{
                                                color: "#fff",
                                                fontSize: {
                                                    xs: "24px",
                                                    md: "30px",
                                                },
                                                fontWeight: 900,
                                                lineHeight: 1.1,
                                            }}
                                        >
                                            Items For Sale
                                        </Typography>

                                        <Typography
                                            sx={{
                                                color: "#666",
                                                fontSize: "12px",
                                                mt: 0.8,
                                            }}
                                        >
                                            Browse the latest
                                            marketplace listings.
                                        </Typography>
                                    </Box>

                                    {/* ITEM COUNT */}
                                    <Box
                                        sx={{
                                            minWidth: 55,
                                            px: 1,
                                            py: 1,
                                            textAlign: "center",
                                            borderRadius: "10px",
                                            background:
                                                "rgba(255,84,32,0.055)",
                                            border:
                                                "1px solid rgba(255,84,32,0.12)",
                                        }}
                                    >
                                        <Typography
                                            sx={{
                                                color: "#ff7135",
                                                fontSize: "17px",
                                                fontWeight: 900,
                                                lineHeight: 1,
                                            }}
                                        >
                                            {result.length}
                                        </Typography>

                                        <Typography
                                            sx={{
                                                color: "#555",
                                                fontSize: "7px",
                                                fontWeight: 800,
                                                letterSpacing:
                                                    "1px",
                                                mt: 0.5,
                                            }}
                                        >
                                            LISTINGS
                                        </Typography>
                                    </Box>
                                </Box>
                            </Box>

                            {renderItems()}
                        </Paper>
                    </Grid>

                    {/* =================================================
                        MAP
                    ================================================== */}
                    <Grid item xs={12} lg={4}>
                        <Paper
                            elevation={0}
                            sx={{
                                height: "100%",
                                p: {
                                    xs: 1.5,
                                    sm: 2,
                                    md: 2.5,
                                },
                                background:
                                    "linear-gradient(145deg, rgba(18,10,8,0.98), rgba(7,7,7,0.99))",
                                border:
                                    "1px solid rgba(255,84,32,0.16)",
                                borderRadius: {
                                    xs: "20px",
                                    md: "24px",
                                },
                                boxShadow:
                                    "0 25px 70px rgba(0,0,0,0.55)",
                                position: "relative",
                                overflow: "hidden",

                                "&:before": {
                                    content: '""',
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    height: "2px",
                                    background:
                                        "linear-gradient(90deg, transparent, #b52a0d, #ff7135, #ff9a4d, #ff5420, transparent)",
                                },
                            }}
                        >
                            {/* SECTION HEADER */}
                            <Box
                                sx={{
                                    px: {
                                        xs: 1,
                                        sm: 1.5,
                                    },
                                    pt: 1,
                                    pb: 2.5,
                                }}
                            >
                                <Typography
                                    sx={{
                                        color: "#ff7135",
                                        fontSize: "10px",
                                        fontWeight: 800,
                                        letterSpacing:
                                            "2px",
                                        textTransform:
                                            "uppercase",
                                        mb: 0.7,
                                    }}
                                >
                                    SELLER LOCATION
                                </Typography>

                                <Typography
                                    sx={{
                                        color: "#fff",
                                        fontSize: {
                                            xs: "24px",
                                            md: "30px",
                                        },
                                        fontWeight: 900,
                                        lineHeight: 1.1,
                                    }}
                                >
                                    Market Map
                                </Typography>

                                <Typography
                                    sx={{
                                        color: "#666",
                                        fontSize: "12px",
                                        mt: 0.8,
                                    }}
                                >
                                    Hover an item to find
                                    its seller.
                                </Typography>
                            </Box>

                            {renderMap()}
                        </Paper>
                    </Grid>
                </Grid>

                {/* =====================================================
                    MARKET INFORMATION
                ====================================================== */}
                <Box
                    sx={{
                        display: "grid",
                        gridTemplateColumns: {
                            xs: "1fr",
                            sm: "repeat(3, 1fr)",
                        },
                        gap: 1,
                        mt: 3,
                    }}
                >
                    {[
                        {
                            value: "5165",
                            label: "CLASSIC MARKET",
                        },
                        {
                            value: "LIVE",
                            label: "PLAYER LISTINGS",
                        },
                        {
                            value: "MAP",
                            label: "SELLER LOCATION",
                        },
                    ].map((item) => (
                        <Box
                            key={item.label}
                            sx={{
                                py: 2,
                                textAlign: "center",
                                border:
                                    "1px solid rgba(255,84,32,0.08)",
                                background:
                                    "rgba(255,255,255,0.018)",
                                borderRadius: "10px",
                            }}
                        >
                            <Typography
                                sx={{
                                    color: "#ff7135",
                                    fontSize: "15px",
                                    fontWeight: 900,
                                    letterSpacing: "1px",
                                }}
                            >
                                {item.value}
                            </Typography>

                            <Typography
                                sx={{
                                    color: "#444",
                                    fontSize: "8px",
                                    fontWeight: 800,
                                    letterSpacing: "1.5px",
                                    mt: 0.3,
                                }}
                            >
                                {item.label}
                            </Typography>
                        </Box>
                    ))}
                </Box>

                {/* =====================================================
                    BOTTOM DECORATION
                ====================================================== */}
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        mt: 5,
                        gap: 2,
                    }}
                >
                    <Box
                        sx={{
                            width: {
                                xs: 45,
                                sm: 70,
                            },
                            height: "1px",
                            background:
                                "linear-gradient(90deg, transparent, rgba(255,84,32,0.3))",
                        }}
                    />

                    <Typography
                        sx={{
                            color: "#444",
                            fontSize: "10px",
                            fontWeight: 700,
                            letterSpacing: "2px",
                            textTransform: "uppercase",
                        }}
                    >
                        Vex Conquer • 5165 Classic
                    </Typography>

                    <Box
                        sx={{
                            width: {
                                xs: 45,
                                sm: 70,
                            },
                            height: "1px",
                            background:
                                "linear-gradient(90deg, rgba(255,84,32,0.3), transparent)",
                        }}
                    />
                </Box>
            </Container>
        </Box>
    );
};

